
/* tslint:disable:no-var-requires */

// Angular 2
import "@angular/compiler";
import "@angular/platform-browser";
import "@angular/platform-browser-dynamic";

import "@angular/common";
import "@angular/core";

import "@angular/forms";
// import "@angular/http";
import "@angular/router";
// import "@angular/testing"; // TODO: reenable

// RxJS
import "rxjs";

// CRC checksums
import "crc-32";

// Angular 2 Modal helpers
import "angular2-modal";

// Bootstrap
import "bootstrap/dist/css/bootstrap.min.css";

// D3 modules
import "d3-force";
import "d3-scale";

// moment already has correct packaging, but the timezone unit doesn't
// NOTE: this also imports the default timezone data package
import "moment-timezone";

// Password strength-checking library
import "zxcvbn";



// WEBPACK FOOTER //
// ./~/angular-router-loader/src!./build-config/vendor.ts